import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Button, Checkbox, Col, Form, Input, Modal, Row, Skeleton, Tag, Tooltip } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ChevronDown, ChevronUp, CloseIcon, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { Images } from '../../config/images';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useShareCountValidation from '../../Hooks/useShareCountValidation';
import { cancelOpenOrderAction, editOrderAction } from '../../store/reducer/portfolioOpenOrderSlice';
import { fetchFundingSourcesAction } from '../../store/reducer/fundingSourcesSlice';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import { PRIMARY_PROPERTY_LABELS, TOOLTIP_TEXT, TRANSACTION_VALIDATION_MESSAGES } from '../../utils/constant';

const EditOrderModal = (props) => {
  const { selectedProperty, propertyDetails, setOpenModal, properyLoading, isSecondaryMarketPaused } = props;
  const [expandAdvanced, setExpandAdvanced] = useState(true);
  const [CancelOrderModal, setCancelOrderModal] = useState(false);
  const [numberOfShare, setNumberOfShare] = useState('');
  const [sellPrice, setSellPrice] = useState('');
  const [duration, setDuration] = useState('Good Until Cancel');
  const [isPartialFills, setIsPartialFills] = useState(false);
  const [isTermAndConditionChecked, setIsTermAndConditionChecked] = useState(false);
  const [EditOrderThree, setEditOrderThree] = useState(false);
  const [SuccessModal, setSuccessModal] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [isTextSelected, setIsTextSelected] = useState(false);
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.portfolioOpenOrder.loading);
  const { walletBalance } = useSelector((state) => state.fundingSources);

  useEffect(() => {
    if (props.EditOrderOne) {
      dispatch(fetchFundingSourcesAction());
    }
  }, [props.EditOrderOne]);
  

  const screenMD = useMediaQuery('(min-width: 1000px)');
  // Order Modals
  const [, setEditOrderOne] = useState(false);

  const [EditOrderTwo, setEditOrderTwo] = useState(false);
  const showEditOrderTwo = () => {
    setNumberOfShare(selectedProperty?.quantity?.toString());
    setSellPrice(selectedProperty?.orderPrice?.toString());
    setDuration(selectedProperty?.duration || 'Good Until Cancel');
    setIsPartialFills(selectedProperty?.partialFills);
    setEditOrderTwo(true);
    setEditOrderOne(false);
  };
  const hideEditOrderTwo = () => {
    setEditOrderTwo(false);
  };
  const showEditOrderThree = () => {
    setEditOrderThree(true);
    setEditOrderTwo(false);
  };
  const hideEditOrderThree = () => {
    setEditOrderThree(false);
    setEditOrderTwo(false);
    setIsTermAndConditionChecked(false);
    // setEditOrderThree(false);
  };
  const showSuccessModal = async () => {
    setOrderType('cancel');
    await dispatch(
      cancelOpenOrderAction({
        id: selectedProperty?.openOrderId,
        onSuccess: () => {
          hideCancelOrderModal();
          props.CloseFunction(false);
          setSuccessModal(true);
          setEditOrderThree(false);
          setOpenModal(false);
          props.onOrderActionSuccess && props.onOrderActionSuccess();
        },
      })
    );
  };

  const handlePlaceOrder = async () => {
    setOrderType('buyOrSell');
    await dispatch(
      editOrderAction({
        id: selectedProperty?.openOrderId,
        formData: {
          noOfShares: Number(numberOfShare),
          pricePerShare: Number(sellPrice),
          partialFills: isPartialFills === null ? false : isPartialFills,
          duration: duration,
        },
        onSuccess: () => {
          hideEditOrderTwo();
          hideEditOrderThree();
          props.CloseFunction(false);
          setIsTermAndConditionChecked(false);
          setSuccessModal(true);
          setEditOrderThree(false);
          props.onOrderActionSuccess && props.onOrderActionSuccess();
        },
      })
    );
  };
  const hideSuccessModal = () => {
    setSuccessModal(false);
    hideCancelOrderModal();
    setOpenModal(false);
  };
  const showCancelOrderModal = () => {
    setCancelOrderModal(true);
    setEditOrderOne(false);
  };
  const hideCancelOrderModal = () => {
    setCancelOrderModal(false);
  };
  const grossPrice = Number(selectedProperty?.quantity) * Number(selectedProperty?.orderPrice);
  const totalPurchase = Number(grossPrice) + Number(selectedProperty?.platformFee);
  const allTime = getUsCurrencyFormat(
    (100 *
      (Number(propertyDetails?.data?.lastPrice ? propertyDetails?.data?.lastPrice : propertyDetails?.data?.finance?.perSharePrice) -
        Number(propertyDetails?.data?.finance?.perSharePrice))) /
    Number(propertyDetails?.data?.finance?.perSharePrice) || 0
  );

  const handleDivToolTipOpen = (e) => {
    e.stopPropagation();
    setToolTipOpen(!toolTipOpen);
  };

  useEffect(() => {
    setNumberOfShare(selectedProperty?.quantity?.toString());
    setDuration(selectedProperty?.duration || 'Good Until Cancel');
    setIsPartialFills(selectedProperty?.partialFills);
    setSellPrice(selectedProperty?.orderPrice?.toString());
  }, [propertyDetails]);

  let grossProceeds = Number(sellPrice) * Number(numberOfShare);
  const transactionFee = (Number(grossProceeds) * 1) / 100;
  const rawNetproceeds =
    selectedProperty?.type === 'Sell'
      ? (numberOfShare && sellPrice ? Math.round((Number(grossProceeds) - Number(transactionFee) - Number(selectedProperty?.platformFee)) * 100) / 100 : 0)
      : Math.round((Number(grossProceeds) + Number(transactionFee) + Number(selectedProperty?.platformFee)) * 100) / 100;
  const Netproceeds = getUsCurrencyFormat(rawNetproceeds);
  const sharesRemainingToPurchase = Number(
    ((Number(propertyDetails?.data?.totalShare) * 9.8) / 100 - Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)).toFixed(2)
  );
  const sharesRemainingToPurchaseForEdit = Math.floor(
    (
      (Number(propertyDetails?.data?.totalShare) * 9.8) / 100 -
      Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) -
      Number(propertyDetails?.data?.userPurchaseDetail?.remainingOpenShares) +
      Number(selectedProperty?.quantity || 0)
    ).toFixed(2)
  );
  const isBuyOrdersPending = propertyDetails?.data?.userPurchaseDetail?.isBuyOrdersPending;
  
  const editSellAvailable = Math.max(
    0,
    Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares || 0) -
      (isBuyOrdersPending ? 0 : Number(propertyDetails?.data?.userPurchaseDetail?.remainingOpenShares || 0)) +
      Number(selectedProperty?.quantity || 0)
  );
  const isMaxRangeError = Number(numberOfShare) > Number(sharesRemainingToPurchaseForEdit);
  const { isBelowMinShares, onShareInputChange } = useShareCountValidation(numberOfShare);
  const hasPendingMatchedTrade = propertyDetails?.data?.hasPendingMatchedTrade;
  const hasUnapprovedTradeBlockingCancel = propertyDetails?.data?.hasUnapprovedTradeBlockingCancel;
  const getEditOrderDisabledReason = () => {
    if (isSecondaryMarketPaused) return 'The Realbricks secondary market trading is temporarily paused.';
    if (selectedProperty?.secondaryOrderStatus === 'PARTIALLY_EXECUTED') return 'This order has been partially executed and cannot be edited.';
    if (hasPendingMatchedTrade) return TOOLTIP_TEXT.PENDING_MATCHED_TRADE_EDIT;
    if (hasUnapprovedTradeBlockingCancel) return TOOLTIP_TEXT.PARTIALLY_MATCHED_PROCESSING_EDIT;
    return '';
  };
  // rawBuyTotal uses the newly computed grossProceeds and transactionFee (1% of new order), not the original order's fees
  const rawBuyTotal = grossProceeds + transactionFee + Number(selectedProperty?.platformFee || 2.5);
  // Guard: only evaluate when wallet data has been loaded (both non-null)
  const showInsufficientBalanceError = selectedProperty?.type === 'Buy'
    && walletBalance != null
    && rawBuyTotal > Number(walletBalance);
  
  return (
    <>
      {screenMD && (
        <>
          {/* <Button onClick={showEditOrderOne}>Edit modal</Button> */}
          <Modal
            className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
            open={props.EditOrderOne}
            onCancel={() => props.CloseFunction(false)}
            title={
              <div className='buy-order-header'>
                <div className='header__img'>
                  {propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage] ? (
                    <LazyLoadImage
                      onError={(element) => {
                        element.target.src = Images.noPropertyFoundImage;
                      }}
                      src={propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage]}
                      alt='house with garden'
                    />
                  ) : (
                    <>{properyLoading ? <Skeleton.Image active={true} /> : <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />}</>
                  )}
                </div>
                <div className='header__content'>
                  <p className='subhead-2 text-copper mb-0'>
                    {propertyDetails?.data?.name || <Skeleton.Input active={true} size='small' style={{ height: 16 }} />}
                  </p>
                  <div className='name-type'>
                    {properyLoading ? (
                      <Skeleton.Input style={{ height: 16 }} active={true} size='small' />
                    ) : (
                      <span className='fz-12 text-taupe'>{`${propertyDetails?.data?.city || ''}, ${propertyDetails?.data?.state || ''}`}</span>
                    )}
                    <span className='fz-14 ml-4 mr-4 text-taupe-60'>•</span>
                    <span className='fz-12 text-taupe'>
                      {propertyDetails?.data?.propertyTypeName || <Skeleton.Input style={{ height: 16 }} active={true} size='small' />}
                    </span>
                  </div>
                  <div className='share-details mt-12'>
                    {selectedProperty?.type !== 'IPO' ? (
                      <>
                        <div className='block'>
                          <span className='text-taupe-80'>Last price</span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{`$ ${getUsCurrencyFormatWithoutDecimal(selectedProperty?.lastPrice || 0) || (
                              <Skeleton style={{ height: 16 }} paragraph={{ rows: 1 }} />
                            )
                              }`}</span>
                          )}
                        </div>
                        <div className='block'>
                          <span className='text-taupe-80'>
                            All time
                            <Tooltip placement='bottom' title='All Time reflects the total change in share price since the initial offering'>
                              <span>
                                <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                              </span>
                            </Tooltip>
                          </span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{`${allTime || ''} %`}</span>
                          )}
                        </div>
                        <div className='block'>
                          <span className='text-taupe-80'>
                            Est. Dividend Yield
                            <Tooltip
                              placement='bottom'
                              popupClassName='div-yeild-pop'
                              title={TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD}
                            >
                              <span>
                                <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                              </span>
                            </Tooltip>
                          </span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{propertyDetails?.data?.tenantStatus?.dividendYield ?? 'NA'}</span>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='block'>
                          {/* <span className='text-taupe-80'>Shares remaining</span>
                          <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(selectedProperty?.sharesRemaining || 0)}</span> */}
                          <span>
                            <span className='text-taupe-80'>Estimated Dividend Yield</span>
                            <Tooltip
                              placement='bottom'
                              open={toolTipOpen}
                              onMouseEnter={() => screenMD && setToolTipOpen(true)}
                              onMouseLeave={() => screenMD && setToolTipOpen(false)}
                              onClick={handleDivToolTipOpen}
                              title={TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD}
                              trigger='hover'
                            >
                              <span className='info-popover'>
                                <Information verticalAlign='-3px' color='#726460' marginLeft='4px' />
                              </span>
                            </Tooltip>
                          </span>
                          <span className='subhead-3'>{propertyDetails?.data?.tenantStatus?.dividendYield ?? 'NA'}</span>
                        </div>
                        {/* Comment out for CR change to hide investor count */}
                        {/* <div className='block'>
                          <span className='text-taupe-80'>Investors</span>
                          <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(selectedProperty?.investors || 0)}</span>
                        </div> */}
                        <div className='block'>
                          <span className='text-taupe-80'>{PRIMARY_PROPERTY_LABELS.SHARE_PRICE}</span>
                          <span className='subhead-3'>{`$ ${getUsCurrencyFormat(selectedProperty?.orderPrice || 0)}`}</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            }
            footer={
              selectedProperty?.type !== 'IPO' ? (
                <>
                  <Row gutter={16} className='mt-8'>
                    <Col span={12}>
                      <Tooltip
                        title={
                          hasPendingMatchedTrade
                            ? TOOLTIP_TEXT.PENDING_MATCHED_TRADE_CANCEL
                            : hasUnapprovedTradeBlockingCancel
                              ? TOOLTIP_TEXT.PARTIALLY_MATCHED_PROCESSING_CANCEL
                              : ''
                        }
                        mouseEnterDelay={0.1}
                        getPopupContainer={trigger => trigger.parentNode}
                      >
                        <span>
                          <Button
                            danger
                            className='w-100 mb-16'
                            onClick={showCancelOrderModal}
                            disabled={properyLoading || hasPendingMatchedTrade || hasUnapprovedTradeBlockingCancel}
                          >
                            Cancel Order
                          </Button>
                        </span>
                      </Tooltip>
                    </Col>
                    <Col span={12}>
                      <Tooltip
                        title={getEditOrderDisabledReason()}
                        mouseEnterDelay={0.1}
                        getPopupContainer={trigger => trigger.parentNode}
                      >
                        <span>
                          <Button
                            className='w-100 mb-16'
                            onClick={showEditOrderTwo}
                            disabled={
                              properyLoading ||
                              isSecondaryMarketPaused ||
                              selectedProperty?.secondaryOrderStatus === 'PARTIALLY_EXECUTED' ||
                              hasPendingMatchedTrade ||
                              hasUnapprovedTradeBlockingCancel
                            }
                          >
                            Edit Order
                          </Button>
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <p className='fz-12 text-taupe-60 text-left'>
                    Please note that orders may be executed at any time during an editing process. If this happens, any changes made to the order
                    during the edit will not be saved.
                  </p>
                </>
              ) : (
                false
              )
            }
            width={524}
            closeIcon={<CloseIcon />}
            centered
          >
            <div className='buy-content mt-20 mb-20'>
              <p className='fw-600 mt-4'>Order details</p>
              <div className='d-flex flex-column g-16 fz-14'>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-almost-black fw-600'>Status</span>
                  <span className='text-almost-black fw-600'>{selectedProperty?.status || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Type</span>
                  <span>{selectedProperty?.type || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Category</span>
                  <span>{(selectedProperty?.isBonusShare ? 'Awarded' : 'Purchased') || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Quantity</span>
                  <span>{selectedProperty?.quantity || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Price per Share</span>
                  <span>{`$${getUsCurrencyFormat(selectedProperty?.orderPrice || 0)}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>{selectedProperty?.type === 'Sell' ? 'Estimated Credit' : 'Total Investment (USD)'}</span>
                  <span className='fw-600'>{`$${getUsCurrencyFormat(grossPrice || 0)}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Platform Fee</span>
                  <span>{`$${getUsCurrencyFormat(selectedProperty?.platformFee || 0)}`}</span>
                </div>
                {selectedProperty?.type === 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Total Purchase (USD)</span>
                    <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || 0)}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                    <span>{`$ ${getUsCurrencyFormat(selectedProperty?.transactionFee) || ''}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>{selectedProperty?.type === 'Sell' ? 'Estimated Net Credit' : 'Total purchase (USD)'}</span>
                    <span className='fw-600'>{`$ ${Netproceeds || ''}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='d-flex align-items-center'>
                      <span className='text-taupe-80'>Partial fills</span>
                      <Tooltip placement='bottom' title={TOOLTIP_TEXT.PARTIAL_FILLS} trigger='hover'>
                        <span className='info-popover'>
                          <Information verticalAlign='-3px' color='#726460' marginLeft='4px' />
                        </span>
                      </Tooltip>
                    </span>
                    <span>{selectedProperty?.partialFills === true ? 'Yes' : 'No'}</span>
                  </div>
                )}
                {/* Duration field commented out - Good Until Cancel / Good for the Day */}
                {/* selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Duration</span>
                    <span>{selectedProperty?.duration || ''}</span>
                  </div>
                ) */}
              </div>
            </div>
          </Modal>
        </>
      )}
      {screenMD && (
        <Modal
          className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
          open={EditOrderTwo}
          onCancel={hideEditOrderTwo}
          title={
            <div className='buy-order-header'>
              <div className='header__img'>
                {propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage] ? (
                  <LazyLoadImage
                    onError={(element) => {
                      element.target.src = Images.noPropertyFoundImage;
                    }}
                    src={propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage]}
                    alt='house with garden'
                  />
                ) : (
                  <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />
                )}
              </div>
              <div className='header__content'>
                <p className='subhead-2 text-copper mb-0'>{propertyDetails?.data?.name || ''}</p>
                <div className='name-type'>
                  <span className='fz-12 text-taupe'>{`${propertyDetails?.data?.city || ''}, ${propertyDetails?.data?.state || ''}`}</span>
                  <span className='fz-14 ml-4 mr-4 text-taupe-60'>•</span>
                  <span className='fz-12 text-taupe'>{propertyDetails?.data?.propertyTypeName || ''}</span>
                </div>
                <div className='share-details mt-12'>
                  <div className='block'>
                    <span className='text-taupe-80'>Last price</span>
                    <span className='subhead-3'>{`$ ${getUsCurrencyFormatWithoutDecimal(selectedProperty?.lastPrice || 0)}`}</span>
                  </div>
                  <div className='block'>
                    <span className='text-taupe-80'>
                      All time
                      <Tooltip placement='bottom' title='All Time reflects the total change in share price since the initial offering'>
                        <span>
                          <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                        </span>
                      </Tooltip>
                    </span>
                    <span className='subhead-3'>{`${allTime || ''} %`}</span>
                  </div>
                  <div className='block'>
                    <span className='text-taupe-80'>
                      Est. Dividend Yield
                      <Tooltip
                        placement='bottom'
                        popupClassName='div-yeild-pop'
                        title={TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD}
                      >
                        <span>
                          <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                        </span>
                      </Tooltip>
                    </span>
                    <span className='subhead-3'>{propertyDetails?.data?.tenantStatus?.dividendYield ?? 'NA'}</span>
                  </div>
                </div>
              </div>
            </div>
          }
          footer={
            <>
              <Row gutter={16} className='mt-8'>
                <Col span={12}>
                  <Button danger className='w-100 mb-16' onClick={() => setEditOrderTwo(false)}>
                    Back
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    disabled={
                      !numberOfShare ||
                      !sellPrice ||
                      Number(sellPrice) < 0.01 ||
                      Number(sellPrice) > 10000 ||
                      Number(numberOfShare) <= 0 ||
                      Number(numberOfShare) % 1 !== 0 ||
                      rawNetproceeds <= 0 ||
                      (rawNetproceeds < 10 || rawNetproceeds > 10000) ||
                      showInsufficientBalanceError ||
                      (selectedProperty?.type === 'Sell'
                        ? Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)
                        : isMaxRangeError)
                    }
                    className='w-100 mb-16'
                    type='primary'
                    onClick={showEditOrderThree}
                  >
                    Preview order
                  </Button>
                </Col>
              </Row>
              <p className='fz-12 text-taupe-60 text-left'>
                Please note that orders may be executed at any time during an editing process. If this happens, any changes made to the order during
                the edit will not be saved.
              </p>
            </>
          }
          width={524}
          closeIcon={<CloseIcon />}
          centered
        >
          <div className='buy-content'>
            <h4 className='fw-600 mt-40 mb-34'>{`Edit ${selectedProperty?.type} order`}</h4>
            <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare}>
              <Form.Item
                className='mb-12'
                validateStatus={
                  (isBelowMinShares || numberOfShare) &&
                  (selectedProperty?.type === 'Sell'
                    ? (Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) ||
                      Number(numberOfShare) % 1 !== 0 ||
                      isBelowMinShares) &&
                    'error'
                    : (Number(numberOfShare) % 1 !== 0 || isMaxRangeError || isBelowMinShares) && 'error')
                }
                help={
                  (isBelowMinShares || numberOfShare) &&
                  (selectedProperty?.type === 'Sell'
                    ? Number(numberOfShare) % 1 !== 0
                      ? 'Decimal numbers are not allowed.'
                      : isBelowMinShares
                        ? TRANSACTION_VALIDATION_MESSAGES.INVALID_SHARE_NUMBER_SELL
                        : Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) &&
                        `You have exceeded the sell out limit.(i.e more than ${propertyDetails?.data?.userPurchaseDetail?.noOfShares} shares)`
                    : Number(numberOfShare) % 1 !== 0
                      ? 'Decimal numbers are not allowed.'
                      : isBelowMinShares
                        ? TRANSACTION_VALIDATION_MESSAGES.INVALID_SHARE_NUMBER_BUY
                        : isMaxRangeError &&
                        `You have exceeded the Buy limit.(i.e more than ${sharesRemainingToPurchaseForEdit} shares)`)
                }
              >
                <Input
                  value={numberOfShare}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setNumberOfShare(value);
                    onShareInputChange(value);
                  }}
                  onSelect={(e) => {
                    window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
                  }}
                  onKeyPress={(event) => {
                    if (selectedProperty?.type === 'Sell') {
                      if (
                        (!/[0-9]/.test(event.key) || Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)) &&
                        !isTextSelected
                      ) {
                        event.preventDefault();
                      }
                    } else if ((!/[0-9]/.test(event.key) || Number(numberOfShare) >= Number(sharesRemainingToPurchaseForEdit)) && !isTextSelected) {
                      event.preventDefault();
                    }
                  }}
                  id='share'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-30 buy-tags'>
              {selectedProperty?.type === 'Sell' ? (
                <Tag
                  className={numberOfShare?.toString() === editSellAvailable?.toString() && 'ant-tag__selected'}
                  onClick={() => setNumberOfShare(editSellAvailable?.toString() || '0')}
                >
                  {`All: ${editSellAvailable || 0}`}
                </Tag>
              ) : (
                <>
                  <Tag
                    className={
                      Number(sharesRemainingToPurchase.toFixed(0)) < 100
                        ? 'ant-tag-disabled'
                        : numberOfShare?.toString() === '100' && 'ant-tag__selected'
                    }
                    onClick={() => setNumberOfShare('100')}
                  >
                    most popular: 100
                  </Tag>
                  <Tag
                    className={numberOfShare?.toString() === sharesRemainingToPurchaseForEdit.toFixed(0).toString() && 'ant-tag__selected'}
                    onClick={() => setNumberOfShare(sharesRemainingToPurchaseForEdit.toFixed(0).toString() || '0')}
                  >
                    {`Max (9.8%): ${getUsCurrencyFormat(sharesRemainingToPurchaseForEdit.toFixed(0) || 0)}`}
                  </Tag>
                </>
              )}
            </div>
            <FloatingLabel label='Limit Price' inputId='shares' inputValue={sellPrice}>
              <Form.Item
                className='mb-12'
                validateStatus={
                  (sellPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(sellPrice)) ||
                  (sellPrice && Number(sellPrice) < 0.01) ||
                  (sellPrice && Number(sellPrice) > 10000) ||
                  (propertyDetails?.data?.minimumPrice && sellPrice && Number(sellPrice) < Number(propertyDetails?.data?.minimumPrice))
                    ? 'error'
                    : ''
                }
                help={
                  sellPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(sellPrice)
                    ? TRANSACTION_VALIDATION_MESSAGES.INVALID_PRICE_FORMAT
                    : sellPrice && Number(sellPrice) < 0.01
                    ? selectedProperty?.type === 'Sell'
                      ? 'Please note that the minimum payment transfer limit is $0.01. Please adjust the Limit Price to proceed.'
                      : 'Please note that the minimum Limit Price is $0.01. Adjust the Limit Price to proceed.'
                    : sellPrice && Number(sellPrice) > 10000
                    ? selectedProperty?.type === 'Sell'
                      ? 'Please note that the maximum payment transfer limit is $10,000. Please adjust the Limit Price to proceed.'
                      : 'Please note that the maximum Limit Price is $10,000. Adjust the Limit Price to proceed.'
                    : propertyDetails?.data?.minimumPrice && sellPrice && Number(sellPrice) < Number(propertyDetails?.data?.minimumPrice)
                    ? `The minimum share price for this property is $${Number(propertyDetails?.data?.minimumPrice).toFixed(2)} per share. Please adjust your price to $${Number(propertyDetails?.data?.minimumPrice).toFixed(2)} or more to place your sell order.`
                    : ''
                }
              >
                <Input
                  value={sellPrice}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                      setSellPrice(val);
                    }
                  }}
                  placeholder='$'
                  onKeyPress={(event) => {
                    const val = event.target.value;
                    const dotIndex = val.indexOf('.');
                    if (
                      !/[0-9.]/.test(event.key) ||
                      (event.key === '.' && val.includes('.')) ||
                      (dotIndex !== -1 && val.slice(dotIndex + 1).length >= 2)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  id='limit'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-30 buy-tags'>
              {selectedProperty?.type === 'Buy' ? (
                <Tag
                  className={sellPrice?.toString() === propertyDetails?.data?.lowestAsk?.toString() && 'ant-tag__selected'}
                  onClick={() => setSellPrice(propertyDetails?.data?.lowestAsk?.toString() || '0')}
                >
                  {`Best ask: $${getUsCurrencyFormat(propertyDetails?.data?.lowestAsk || 0)}`}
                </Tag>
              ) : (
                <Tag
                  className={sellPrice?.toString() === propertyDetails?.data?.highestBid?.toString() && 'ant-tag__selected'}
                  onClick={() => setSellPrice(propertyDetails?.data?.highestBid?.toString() || '0')}
                >
                  {`Best bid: $${getUsCurrencyFormat(propertyDetails?.data?.highestBid || 0)}`}
                </Tag>
              )}
              <Tag
                className={sellPrice?.toString() === selectedProperty?.lastPrice?.toString() && 'ant-tag__selected'}
                onClick={() => setSellPrice(selectedProperty?.lastPrice?.toString() || '0')}
              >
                {`Last price: $${getUsCurrencyFormat(selectedProperty?.lastPrice || 0)}`}
              </Tag>
            </div>
            {/* Duration dropdown commented out - default value 'Good Until Cancel' is sent in payload */}
            {/* <FloatingLabel label='Duration' inputId='duration' inputValue={duration}>
              <>
                <div id='duration2-anchor' />
                <Form.Item className='mb-12' name='duration'>
                  <Select
                    id='duration'
                    popupClassName='filter-select-dropdown'
                    onChange={(value) => setDuration(value)}
                    value={duration}
                    defaultValue={duration}
                    getPopupContainer={() => document.getElementById('duration2-anchor')}
                    onDropdownVisibleChange={() => setArrowUpDuration2(!arrowUpDuration2)}
                    suffixIcon={arrowUpDuration2 ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  >
                    <Select.Option value='Good Until Cancel'>Good until cancel</Select.Option>
                    <Select.Option value='Good For The Day'>Good for the day</Select.Option>
                  </Select>
                </Form.Item>
              </>
            </FloatingLabel> */}
            <div className='basic-info'>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Estimated Credit</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(grossProceeds || 0)}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Platform fee</span>
                <span className='basic-info__item__value'>$2.50</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Broker-Dealer/ATS Fee (1%)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(transactionFee || 0)}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Estimated Net Credit</span>
                <span className='basic-info__item__value fw-600'>{`$${Netproceeds || ''}`}</span>
              </div>
              {numberOfShare && sellPrice && rawNetproceeds <= 0 && (
                <span className='text-error fz-14'>Total transaction amount must be greater than $0.</span>
              )}
              {numberOfShare && sellPrice && rawNetproceeds > 0 && rawNetproceeds < 10 && (
                <span className='text-error fz-14'>{TRANSACTION_VALIDATION_MESSAGES.MIN_AMOUNT}</span>
              )}
              {numberOfShare && sellPrice && rawNetproceeds > 10000 && (
                <span className='text-error fz-14'>{TRANSACTION_VALIDATION_MESSAGES.MAX_AMOUNT}</span>
              )}
            </div>
            <div className='mb-40 mt-20 fz-16'>
              <p className='fw-600 mb-8 cursor-pointer' onClick={() => setExpandAdvanced(!expandAdvanced)}>
                Advanced {expandAdvanced ? <ChevronUp verticalAlign='-7px' /> : <ChevronDown verticalAlign='-7px' />}
              </p>
              {!!expandAdvanced && (
                <div className='options'>
                  <Checkbox checked={isPartialFills} onChange={(e) => setIsPartialFills(e.target.checked)} className='fz-16'>
                    Accept partial fills
                    <Tooltip
                      popupClassName='div-yeild-pop'
                      title={TOOLTIP_TEXT.PARTIAL_FILLS}
                    >
                      <span>
                        <Information className='cursor-pointer' marginLeft='4px' verticalAlign='sub' color='#726460' />
                      </span>
                    </Tooltip>
                  </Checkbox>
                  {showInsufficientBalanceError && (
                    <div className='pt-10 error-text'>
                      <span className='fz-14'>Insufficient balance</span>
                      <div>
                        <span style={{ cursor: 'pointer' }}>
                          Please go to <a href='/account/transactions'>My Account&gt;Account Balances</a> to transfer funds into your account.
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
      {screenMD && (
        <Modal
          className='quickbuy review-buy-order ant-modal--footer-shadow ant-modal--footer'
          open={EditOrderThree}
          onCancel={hideEditOrderThree}
          footer={
            <>
              <Row gutter={16} className='mt-8 mb-8'>
                <Col span={12}>
                  <Button
                    danger
                    className='w-100'
                    onClick={() => {
                      setEditOrderTwo(true);
                      setEditOrderThree(false);
                      setIsTermAndConditionChecked(false);
                    }}
                  >
                    Back
                  </Button>
                </Col>
                <Col span={12}>
                  <Button loading={loading} disabled={!isTermAndConditionChecked} className='w-100' type='primary' onClick={() => handlePlaceOrder()}>
                    Place order
                  </Button>
                </Col>
              </Row>
            </>
          }
          width={524}
          closeIcon={<CloseIcon />}
          centered
        >
          <h4 className='text-center mb-24'>{`Review ${selectedProperty?.type || ''} order`}</h4>
          <p className='fw-600'>Investment details</p>
          <div className='buy-content'>
            <div className='d-flex flex-column g-16 fz-14'>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Shares</span>
                <span className='basic-info__item__value'>{numberOfShare || ''}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Price per share</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(sellPrice || 0)}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Estimated Credit</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(grossProceeds || 0)}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Platform fee</span>
                <span className='basic-info__item__value'>$2.50</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(transactionFee || 0)}`}</span>
              </div>
              <hr />
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Estimated Net Credit</span>
                <span className='basic-info__item__value fw-600'>{`$${Netproceeds || ''}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Duration</span>
                <span className='basic-info__item__value'>{duration || ''}</span>
              </div>
            </div>
            <div className='d-flex mt-48'>
              <Checkbox checked={isTermAndConditionChecked} onChange={(e) => setIsTermAndConditionChecked(e.target.checked)} className='mr-16' />
              <span className='cursor-pointer fz-14'>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>I have read and accept the </span>
                <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
                  Terms of Use
                </Link>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>, the </span>
                <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
                  Regulation A Investment Disclosure
                </Link>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>, and </span>
                <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
                  Privacy Policy
                </Link>
                .
              </span>
            </div>
          </div>
        </Modal>
      )}
      {screenMD && (
        <Modal className='success' open={SuccessModal} onCancel={hideSuccessModal} closeIcon={<CloseIcon />} footer={false} width={524} centered>
          <div className='mb-16 success__vector'>
            <LazyLoadImage src={Images.success} alt='success vector art' />
          </div>
          <h4 className='success__title'>
            {orderType === 'cancel' ? 'Order cancelled' : (selectedProperty?.type || '') === 'Buy' ? 'Buy order updated' : 'Sell order updated'}
          </h4>
          <p className='mb-48 text-taupe'>
            {orderType === 'cancel'
              ? `You have successfully cancelled your order of ${numberOfShare || ''} shares ($${getUsCurrencyFormat(selectedProperty?.orderPrice || 0)} each) of ${selectedProperty?.property || ''
              }. You will receive a confirmation via email.`
              : selectedProperty?.type === 'Buy'
                ? `You have successfully placed a buy order of ${numberOfShare || ''} shares ($${getUsCurrencyFormat(sellPrice || 0)} each) of ${selectedProperty?.property || ''
                }.`
                : `You have successfully placed a Sell order of ${numberOfShare || ''} shares ($${getUsCurrencyFormat(sellPrice || 0)} each) of ${selectedProperty?.property || ''
                }.`}
          </p>
          <Button type='primary' className='w-100' onClick={hideSuccessModal}>
            Done
          </Button>
        </Modal>
      )}
      {screenMD && (
        <Modal open={CancelOrderModal} onCancel={hideCancelOrderModal} footer={false} closeIcon={<CloseIcon />} width={524} centered>
          <h4 className='text-center mb-16'>Cancel your order?</h4>
          <p className='mb-48'>
            This will remove your order and you may lose your place in the queue. If you'd like to make changes instead, tap Back to edit your order details.
          </p>
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12}>
              <Button className='w-100' onClick={hideCancelOrderModal}>
                Back
              </Button>
            </Col>
            <Col span={24} sm={12}>
              <Button loading={loading} className='w-100' type='primary' danger onClick={showSuccessModal}>
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

EditOrderModal.propTypes = {
  selectedProperty: PropTypes.shape({
    isBonusShare: PropTypes.bool,
    quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    orderPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    duration: PropTypes.string,
    partialFills: PropTypes.bool,
    openOrderId: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
    lastPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    platformFee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transactionFee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    property: PropTypes.string,
    sharesRemaining: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    investors: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  propertyDetails: PropTypes.object,
  setOpenModal: PropTypes.func,
  properyLoading: PropTypes.bool,
  CloseFunction: PropTypes.func,
  EditOrderOne: PropTypes.bool,
  isSecondaryMarketPaused: PropTypes.bool,
  onOrderActionSuccess: PropTypes.func
};

export default EditOrderModal;
